import { authentication } from '@ecosystem/newron-client-lib';
import { getImpersonationHeader } from './impersonation';

interface Config {
  data_delivery_positions?: number[];
}
export interface AuthResult {
  product: string;
  internalProduct: string;
  approved: {
    config?: Config;
    cell: string;
  }[];
}

export interface AuthResultV2 {
  approved: {
    cell: string;
    config?: {
      'reduced_data.weeks'?: string[] | null;
      'reduced_data.months'?: string[] | null;
    };
    resources: Record<string, { start_date: string; end_date: string }>;
  }[];
  rejected: string[];
}

export const ResourceCodeV2 = {
  PosDimensionMarket: 'pos.dimension.market',
  PosKpiTPR: 'pos.kpi.tpr',
  PosKpiRevenuePremium: 'pos.kpi.revenue-premium',
  DistributorFull: 'dist.full',
} as const;

export const PersonaPropositionType = {
  MARKET: 'market',
  PREDICT: 'predict',
  DP: 'distributor_panel',
  RETAIL: 'retail',
} as const;

export type PersonaProposition = (typeof PersonaPropositionType)[keyof typeof PersonaPropositionType];

// Current supported proposition type from newron core
export const PropositionType = {
  Market: 'market',
  DistributionPanel: 'dp',
} as const;

export type Proposition = (typeof PropositionType)[keyof typeof PropositionType];

export function getPropositionHeaderValue(proposition: string): string {
  const MarketPropositionVsPersonaPropositionValuesMap: Record<string, string> = {
    [PropositionType.Market]: PersonaPropositionType.MARKET,
    [PropositionType.DistributionPanel]: PersonaPropositionType.DP,
  };
  return MarketPropositionVsPersonaPropositionValuesMap[proposition];
}

const apiPath = `/api/persona/`;

export const fetchAuth = async <T>(path: string, query: string, proposition: string): Promise<T> => {
  const token = await authentication.getAccessToken();
  const impersonationHeader = getImpersonationHeader();
  const fullApiUrl = `${apiPath}${path}?${query}`;
  const propositionHeaderValue = getPropositionHeaderValue(proposition);
  const headers = {
    Authorization: `Bearer ${token}`,
    ...impersonationHeader,
  };
  // check if valid propositon string was passed
  if (propositionHeaderValue) {
    headers['x-proposition'] = propositionHeaderValue;
  }
  const result = await fetch(fullApiUrl, {
    headers,
  });

  return (await result.json()) as T;
};
